<template>
    <div class="card-main-div" ref="scrollable">
        <div class="card-content">
            <div v-if="title" class="d-flex align-center justify-space-between" style="margin-bottom:30px;">
                <div style="font-size: 20px; font-weight: 700;">{{ title }}</div>
                <div v-if="smallScreen" style="color: #495B8F;">(Step {{ index + 1 }} of 5)</div>
            </div>
            <add-students @go="go"
                v-if="component === 'students'"
                v-model="students"
                :fastbridgeMonitor="fastbridgeMonitor"
                @scrollToTop="scrollToTop"
                :preSelectedStudents="preSelectedStudents"
            ></add-students>
            <intervention-details @go="go"
                v-else-if="component === 'details'"
                v-model="details"
                :interventionists="users"
                :students="students"
                :fastbridgeMonitor="fastbridgeMonitor"
            ></intervention-details>
            <schedule @go="go"
                v-else-if="component === 'schedule'"
                v-model="schedule"
                :students="students"
                :isAttendance="monitorCategoryId === 3"
            ></schedule>
            <monitor-assessment @go="go"
                v-else-if="component === 'monitor' && monitorCategoryId !== 2"
                v-model="monitorAssessment"
                :students="students"
                :schedule="schedule"
                :monitoringUsers="users"
                @scrollToTop="scrollToTop"
                :fastbridgeMonitor="fastbridgeMonitor"
            ></monitor-assessment>
            <monitor-point-sheet @go="go"
                v-else-if="component === 'monitor' && monitorCategoryId === 2"
                v-model="monitorPointSheet"
                :strategy="details.intervention_type_id"
            ></monitor-point-sheet>
            <review @go="go" @createdPlan="createdPlan"
                v-else-if="component === 'review'"
                :students="students"
                :details="details"
                :schedule="schedule"
                :monitorAssessment="monitorAssessment"
                :monitorPointSheet="monitorPointSheet"
                :fastbridgeMonitor="fastbridgeMonitor"
            ></review>
            <completed
                v-else-if="component === 'completed'"
                :interventionist="details.user_id || {}"
                :interventionName="details.intervention_name || ''"
                :interventionPlanId="interventionPlanId || 0"
                :students="students || []"
                :reminderAvailable="monitorCategoryId !== 2 && monitorCategoryId !== 3"
                @createNew="$emit('createNew')"
                @close="$emit('close')"
            ></completed>
        </div>
    </div>
</template>

<script>
import AddStudents from './AddStudents.vue'
import InterventionDetails from './InterventionDetails.vue'
import Schedule from './Schedule.vue'
import MonitorAssessment from './MonitorAssessment.vue'
import MonitorPointSheet from './MonitorPointSheet.vue'
import Review from './Review.vue'
import Completed from './Completed.vue'

export default {
    name: 'Card',

    components: {
        AddStudents,
        InterventionDetails,
        Schedule,
        MonitorAssessment,
        MonitorPointSheet,
        Review,
        Completed,
    },

    props: {
        component: {},
        title: {},
        index: {},
        fastbridgeMonitor: {
            type: Object,
            required: false,
            default: () => {},
        },
        preSelectedStudents: {
            type: Array,
            default: () => []
        },
        value: {
            type: Object,
            default: () => {}
        },
        smallScreen: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        monitorCategoryId() {
            return this.details?.intervention_type_id?.monitor_category_id
        }
    },

    data() {
        return {
            editing: false,
            interventionPlanId: null,
            students: [],
            details: {},
            users: [],
            schedule: {},
            monitorAssessment: [],
            monitorPointSheet: {},
        }
    },

    created() {
        if(this.value) {
            this.students = this.value.students
            this.details = this.value.intervention
            this.schedule = this.value.schedule
            this.monitorAssessment = this.value.monitors
        }
        // load interventionists and monitoring users
        this.$axios.get(this.$models.getUrl('user', 'read') + '&active=1')
            .then(response => {
                this.users = response.data
            })
    },

    watch: {
        'details.intervention_type_id': {
            handler() {
                if (this.details?.intervention_type_id?.monitor_category_id === 2) {
                    this.$emit('monitorType', 'point-sheet')
                } else if (this.details?.intervention_type_id?.monitor_category_id === 3) {
                    this.$emit('monitorType', 'participation')
                } else {
                    this.$emit('monitorType', 'assessment')
                }
            },
        }
    },

    methods: {
        createdPlan(interventionPlanId) {
            this.interventionPlanId = interventionPlanId
            this.$emit('go', 'completed')
        },
        scrollToTop() {
            this.$refs.scrollable.scrollTop = 0
        },
        go(v) {
            this.$emit('go', v || 'continue')
            this.$nextTick(() => this.scrollToTop())
        },
    }
}
</script>

<style lang="scss" scoped>
.card-content {
    background: #fff;
    height: auto;
    width: 600px;
    margin: 0 auto;
    border-radius: 8px; 
    border: 1px solid #ECEDF1; 
    padding: 32px;
    color: #050F2D;
    ::v-deep .v-label {
        color: #050F2D !important;
    }

    ::v-deep .v-autocomplete {
       .v-input__slot {
            border: 1px solid #7e8494;
        }
    }
    ::v-deep .v-text-field {
       .v-input__slot {
            border: 1px solid #7e8494;
        }
    }
}
.card-main-div {
    background: #F3F5F7;
    max-height: 100%;
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: auto;
}
::v-deep .card-bottom {
    margin-left: -8px;
}

.action-link {
    color: #006C90;
    font-size: 14px;
    text-decoration: none;
}

.action-link::after {
    content: '→';
    margin-left: 5px;
}
</style>